/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let VendorCollectionProductsImport;

/** ****************************
 * Vendor Collection Product *
 ***************************** */
export const VendorCollectionProductsLoad = () => import(
  /*
    webpackPrefetch: true,
    webpackChunkName: "vendor-collection-products"
  */
  './subcomponents/VendorCollectionProducts')
  .then((module) => {
    const { VendorCollectionProducts } = module;

    VendorCollectionProductsImport = (props) => {
      return (
        <QueryProvider dataSource="searchNav" defaultVariables={props.qctx.defaultVariables.current} cacheKey="vendor-collection-products">
          <VendorCollectionProducts {...props} />
        </QueryProvider>
      );
    };
  });

export const VendorCollectionProducts = ssr
  ? __webpack_require__(require.resolveWeak('./subcomponents/VendorCollectionProducts')).VendorCollectionProducts
  : (props) => <VendorCollectionProductsImport {...props} />;